import { Toggle } from '@nimbus-ds/components';
import useTranslationOrders from 'domains/Orders/useTranslationOrders';

interface ExactProductSetToggleProps {
  active: boolean;
  onChange: () => void;
}

export function ExactProductSetToggle({
  active = false,
  onChange,
}: Readonly<ExactProductSetToggleProps>): JSX.Element {
  const t = useTranslationOrders('productSearcher.searcherConfirm');
  return (
    <Toggle
      name="exactProductSetToggle"
      label={t('exactProductSetToggle')}
      active={active}
      onChange={onChange}
    />
  );
}
